import Layout from '@layouts/Desktop';
import { PricerModes } from '@pages/Pricers/enums';
import { useAppSelector } from '@store/hooks';
import { isDefAndNotNull } from '@utils/def';
import { FC, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { PricerPagePermissions } from '../../../../models/Permissions/enum';

import Loading from '../../../Loading';

import { Props } from './types';

const SafeRoutePricer: FC<Props> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, sessionLoading, authChecked, permissions } =
    useAppSelector((state) => state.auth);
  const queryParams = new URLSearchParams(location.search);
  const pricerType = queryParams.get('pricerType');

  if (!authChecked || sessionLoading) {
    return <Loading size={50} containerMode />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    isDefAndNotNull(pricerType) &&
    !permissions.includes(
      PricerPagePermissions[pricerType as unknown as PricerModes],
    )
  ) {
    return <Navigate to="/no-access" replace />;
  }

  return (
    <Layout addFiltersComponent={false}>
      <Suspense fallback={<Loading size={50} containerMode />}>
        {children}
      </Suspense>
    </Layout>
  );
};

export default SafeRoutePricer;
